import {cartSvg as Icon__small__cartSvg} from '../Icon__small/Icon__small--cart.js';

export var cart = {
  name: 'cart',
  category: 'icon',
  colorable: true,
  svg: Icon__small__cartSvg,
};
